import { render, staticRenderFns } from "./TgUpperUser.vue?vue&type=template&id=658cf512"
import script from "./TgUpperUser.vue?vue&type=script&lang=js"
export * from "./TgUpperUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports